export const PaytmGatewayNewMethod = (optionsObj) => {
  // Required parameters for token-based integration
  const requiredParams = ["txnToken", "orderId", "mid"];

  const missingParams = requiredParams.filter((param) => !optionsObj[param]);

  if (missingParams.length > 0) {
    alert(`Payment failed: Missing ${missingParams.join(", ")}`);
    return;
  }

  // Determine environment based on WEBSITE parameter
  const isStaging = optionsObj?.website === "WEBSTAGING";

  // UPDATED URLs as per new Paytm documentation
  const paytmUrl = isStaging
    ? "https://securestage.paytmpayments.com/theia/api/v1/showPaymentPage"
    : "https://secure.paytmpayments.com/theia/api/v1/showPaymentPage";

  // Only 3 parameters needed for token-based flow
  const params = {
    mid: optionsObj?.mid,
    orderId: optionsObj?.orderId,
    txnToken: optionsObj?.txnToken,
  };

  const formAction = {
    action: paytmUrl,
    params,
  };

  post(formAction);
};

// ============= HELPER FUNCTIONS =============

function isDate(val) {
  return Object.prototype.toString.call(val) === "[object Date]";
}

function isObj(val) {
  return typeof val === "object";
}

function stringifyValue(val) {
  if (isObj(val) && !isDate(val)) {
    return JSON.stringify(val);
  } else {
    return val;
  }
}

function buildForm({ action, params }) {
  const form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", action);

  Object.keys(params).forEach((key) => {
    // Only add parameters that have values
    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      const input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", key);
      input.setAttribute("value", stringifyValue(params[key]));
      form.appendChild(input);
    }
  });

  return form;
}

function post(details) {
  const form = buildForm(details);
  document.body.appendChild(form);
  form.submit();
  form.remove();
}
